import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { useCopy } from '@/hooks/useCopy';
import { redirectToCentralizedLogin } from '@/auth/silentRefresh';

export function SignedOut() {
  const { t } = useCopy();
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper sx={{ p: 4 }} elevation={1}>
        <Typography variant="h1" component="h1" gutterBottom>
          {t('auth.signedOutTitle', "You're signed out")}
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          {t('auth.signedOutBody', 'Your platform-admin session has ended.')}
        </Typography>
        <Box>
          <Button variant="contained" onClick={() => redirectToCentralizedLogin('/')}>
            {t('auth.signInAgain', 'Sign in again')}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
